export default __webpack_public_path__ + "static/5c12e5620da838a51df8c1f87ee06873.svg";